<template>
  <div class="goods-box my-form">
    <div class="banner">
      <img v-if="actData.banners" :src="actData.banners" >
      <img v-else src="@/assets/img/avatar.png" >
      <p>{{actData.title||''}}</p>
    </div>
    <div class="registered">
        <van-form @submit="onSubmit" show-error :show-error-message="false">
            <van-field
                v-model="form.name"
                name="真实姓名"
                label="真实姓名"
                placeholder="请输入真实姓名"
                :rules="[{ required: true, message: '请填写真实姓名' }]"
            />
            <van-field
                v-model="form.phone"
                type="number"
                name="pattern"
                label="手机号码"
                maxlength="11"
                placeholder="请输入手机号码"
                :rules="[{ pattern, message: '请填写手机号码' }]"
            />
            <van-field
                v-model="code"
                center
                clearable
                label="验证码"
                maxlength="6"
                placeholder="请输入验证码"
                :rules="[{ required: true, message: '请输入验证码' }]"
                >
                <template #button>
                  <span class="code" v-if="newTimer">{{ newCount || 0}}s重新发送</span>
                  <span class="sendcode code" v-else @click="getCode">发送验证码</span>
                </template>
            </van-field>
             <van-field
                v-model="form.compName"
                type="text"
                name="公司"
                label="公司"
                placeholder="请输入公司"
                :rules="[{ required: true, message: '请填写公司' }]"
            />
             <van-field
                v-model="form.jobTitle"
                type="text"
                name="职务"
                label="职务"
                placeholder="请输入职务"
                :rules="[{ required: true, message: '请填写职务' }]"
            />
            <div style="margin: 10px 0;">
                <van-field
                    v-model="form.remark"
                    rows="4"
                    type="textarea"
                    maxlength="50"
                    placeholder="请输入备注说明"
                    :rules="[{ required: false, message: '请输入备注说明' }]"
                    />
            </div>
            <div class="vant-btn">
                <van-button round block type="info"  native-type="submit">
                  {{actData && actData.enabledBuyingTicket ? '下一步' : '提交'}}
                </van-button>
            </div>
        </van-form>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import { mapActions, mapGetters } from "vuex";
import provincial from '@/assets/js/provincial.json';     //省市区json
export default {
  data() {
    return {
      form: {
        name: "", // 真实姓名
        phone: "", // 手机号
        compName: "", // 所属公司
        jobTitle: "", // 职务
        remark:'', //备注说明
      },
      //验证码
      code:'',
      count: 0,
      newCount: 0,
      timer: null,
      newTimer: null,
      codeKey:'',
      //验证码
      pattern: /^1[3456789]\d{9}$/, // 校验手机号
      areaList:[], // 地区数据
      areavalue:[], // 选中的地区数据
      cityCode:'',  //省市区编号，默认
      checkbox:false,
      showArea:false,
      actData:{},
      actInfo:{}
      
    };
  },
  components:{  },
  computed: {
    ...mapGetters({
      user: "getUserInfo",
      categoryList:'getCategory',
      userId:"getUserId",
      hostInfo:"getHostInfo",
      exhibitionId:'getExhibitionId',
      OrderMsg:'wxPay/getOrder'
    }),
    actId(){
      return  this.$route.params.id
    }
  },
  created() { 
      this.$toast.loading({
        message:'loading...',
        forbidClick:true
      })
      this.init();
  },
  methods: {
    ...mapActions({
      activityReg:'act/activityReg',
      LinkToActOrder:'linkTo/LinkToActOrder',
      validateCode:'my/validateCode',
      sendCode:'my/sendCode',
    }),
    async init(){
        await this.$Myapollo.getUserInfo(this);
        await this.getActInfo();
        
        this.form.name = this.user.name;
        this.form.phone = this.user.phone;
        this.form.compName = this.user.company;
        this.form.jobTitle = this.user.jobTitle;
        // if (this.user.province && this.user.city && this.user.county) {
        //   this.areavalue = [
        //     this.user.province,
        //     this.user.city,
        //     this.user.county
        //   ];
        //   this.form.area =
        //     this.user.province +
        //     "/" +
        //     this.user.city +
        //     "/" +
        //     this.user.county;

        //   // console.log(this.areavalue);
        // } else if (this.user.province && this.user.city) {
        //   this.form.area = this.user.province + "/" + this.user.city;
        //   this.areavalue = [this.user.province, this.user.city];
        // } else {
        //   this.form.area = this.user.province;
        //   this.areavalue = [this.user.province];
        // }
        // this.form.remark = this.user.remark;
        this.$toast.clear();
    },
    onCity(e){ //选择地区
       console.log(e,'选择地区');
       let areaList = [];
       e.forEach(c => {
        areaList.push(c.name)
       });
       this.areavalue = areaList;
       this.form.area = areaList.join("/");
       this.showArea = false
    },
    getActInfo(){
      return new Promise((resolve,reject)=>{
        let query=gql`
        query activity($id: Guid!){
            actInfo: activity(id: $id){
              banners
              acvitityType
              regStartAt
              regEndAt
              company{
                name
                id
                logo
              }
              exhibitorId
              exhibitionId
              title
              enabledBuyingTicket
            }
          }`
        this.$apollo.addSmartQuery('actInfo',{
          query:query,
          fetchPolicy: "no-cache", //清理缓存
          variables: {
            id:this.actId
          },
          result(res){
            if(res){
              let data=JSON.parse(JSON.stringify(res.data.actInfo));
              if(data.banners){
                data.banners=JSON.parse(data.banners)[0];
              }
              this.actData=data;
              // console.log(data); 
              resolve(data);
            }
            resolve(res);
          },// 错误处理
          error(error) {
              console.error(error,'error错误处理');
            reject(error);
          }
        })
      })
    },
    async onSubmit(){
      let checkRes =  await this.Checkphone();
      if(!checkRes) {
        return;
      }
      let MobBody = {
        memberId:this.user.id,
        phonenNumber:this.form.phone,
      }
      let body = {
        activityId:this.actId,
        exhibitionId:this.actData.exhibitionId, 
        exhibitorId: this.actData.exhibitionId,
        memberId: this.user.id,
        userId:this.user.userId,
        fullName: this.form.name,
        phoneNumber:this.form.phone,
        company: this.form.compName,
        jobTitle: this.form.jobTitle,
        remark: this.form.remark,
      };
      let result=await this.activityReg(body)
      if(result.result){ // 注册成功
        if(this.actData.enabledBuyingTicket){ // 购票进入
          let opt = {
              actId:this.OrderMsg.actId, // 活动的id
              num:this.OrderMsg.num, // 购票的数量
              totalPrice:this.OrderMsg.totalPrice, // 总价
              title:this.OrderMsg.title,
              joinName:this.form.name, // 报名人信息
              regId:result.data,
          };
          this.$store.commit('wxPay/setOrder',opt);
          setTimeout(() => {
            this.LinkToActOrder(this.actId); 
          }, 500);
        } else {
          this.$toast.success({
            message:'报名成功',
            forbidClick:true
          });
          setTimeout(() => {
            this.$router.go(-1);
          }, 500);
        }
      } else{  // 注册失败
        this.$toast.fail(result.message);
      }
    },
    //手机号校验
    validatorPhone(val) {
      return /^1[3456789]\d{9}$/.test(val);
    },
    // 获取手机号验证码
    async getCode(){
      console.log(this.form.phone,'123213')
      if (!this.validatorPhone(this.form.phone)) {
        this.$toast.fail('请输入正确的手机号')
        return;
      } else {
        this.newDownTime();
        let res = await this.sendCode({
          PhoneNumber: this.form.phone
        });
        if (res.result) {
          this.codeKey = res.data.key;
        } else {
          this.$toast.fail('发送失败')
        }
      }
    },
    //验证手机号
    async Checkphone() {
      let res = await this.validateCode({
        key: this.codeKey,
        code: this.code
      });
      return new Promise((resolve, reject) => {
        if (res == true) {
          this.resetDown();
          resolve(true);
        } else {
          this.$toast.fail('手机号验证失败')
          this.resetDown();
          resolve(false);
        }
      })
    },


    resetDown(){ // 重置验证码
      clearInterval(this.newTimer);
      this.newCount = 0;
      this.newTimer = null;
      this.code = "";
    },

    //新手机号倒计时
    newDownTime() {
      const newTIME_COUNT = 60;
      if (!this.newTimer) {
        this.newCount = newTIME_COUNT;
        const newTimer = setInterval(() => {
          let count = this.newCount;
          if (count > 0 && count <= newTIME_COUNT) {
            count--;
            this.newCount = count;
          } else {
            clearInterval(this.newTimer);
            this.newTimer = null;
          }
        }, 1000);
        this.newTimer = newTimer;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.goods-box {
  width: 100%;
  min-height: 100vh;
  background-color: rgb(245, 245, 245);
  display: flex;
  flex-direction: column;
  align-items: center;
  .banner{
    background: #fff;
    width: 100%;
    margin-bottom: 0.2rem;
    img{
      width: 100%;
      height: 4.2rem;
      display: block;
      // object-fit: cover;
    }
    p{
      font-size: 0.34rem;
      color: #222;
      height: 0.98rem;
      padding-left: 0.3rem;
      font-weight: bold;
      display: flex;
      align-items: center;
    }
  }

  .registered {
    width: 100%;
    padding-bottom: .9rem;
    .code{
        font-size: .3rem;
    }
    .sendcode{
        color: #0190fe;
    }
    .single-checkbox{
        margin:.6rem 0 .8rem .3rem;
        display: flex;
        p{
           font-size: .3rem; 
           margin-left: 5px;
           color: #666;
        }
        span{
            font-size: .3rem;
            color: #1890ff
        }
    }
    .vant-btn{
        position: fixed;
        left:0;
        bottom: 0;
        z-index: 100;
        width: 100%;
        background: #fff;
        height: .94rem;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0px 0px 3px 0px 
        rgba(0, 0, 0, 0.2);
        .van-button--block{
            width: 6.5rem;
            height: .74rem;
            line-height: .74rem;
        }
        span{
            font-size: .3rem;
        }
    }
    .van-cell__value{
      span{
        font-size: .3rem;
      }
      .icon-xiala{
        display: block;
        transform: translateY(-0.04rem);
      }
    }
    

    }
}
</style>